import React, { useEffect } from 'react';
import DeleteBtn from '../../components/buttons/DeleteBtn';
import PrimaryBtn from '../../components/buttons/PrimaryBtn';
import CancelBtn from '../../components/buttons/cancel/CancelBtn';
import { IFormLayout } from '../../interfaces/components/layout.interface';

const FormLayout: React.FC<IFormLayout> = ({
  children,
  classname,
  formName,
  deleteCallback,
  saveCallback,
  cancelCallback,
  disabledDeletButton,
  hideDeleteButton = false,
  isFullScreen = true,
  buttonTitle = 'Lưu',
}) => {
  useEffect(() => {
    window &&
      window.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e?.key && e?.key === 'Escape') {
          cancelCallback && cancelCallback();
        }
      });

    return () => {
      window && window.addEventListener('keydown', () => {});
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    // change from MainLayout to a simple div for easier customization
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      className="relative flex flex-col p-6 md:mx-auto md:max-h-[90dvh] md:w-[568px] md:rounded-lg md:bg-white md:pb-[54px]"
    >
      <div
        className={`flex min-h-full flex-1 flex-col ${classname && classname}`}
      >
        <div className="sticky top-0 z-20 flex items-center justify-start gap-6 bg-white">
          <CancelBtn
            callback={() => {
              cancelCallback && cancelCallback();
            }}
          />
          <p className="-mt-1 font-semibold uppercase">{formName}</p>
        </div>
        <article
          className={`${isFullScreen ? 'flex-1' : ''} sm:overflow-y-scroll`}
        >
          {children}
        </article>
        <div className={`mt-3 flex w-full items-center justify-center py-5`}>
          {!hideDeleteButton && (
            <DeleteBtn
              disabled={disabledDeletButton}
              callback={() => deleteCallback()}
            />
          )}
          <PrimaryBtn
            callback={() => saveCallback()}
            classname={`${!hideDeleteButton && 'ml-4'}`}
          >
            {buttonTitle}
          </PrimaryBtn>
        </div>
      </div>
    </div>
  );
};

export default FormLayout;
